<template>
  <ui-select
    v-model="value"
    :items="data"
    item-text="text"
    item-value="value"
    :autocomplete="false"
    :prepend-inner-icon="icon"
    :hide-details="1"
  ></ui-select>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import query from '@/components/query/query-constructor';
import { useStore } from '@/store';
import { useI18n } from '@/composables/useI18n';

const { t } = useI18n();
const store = useStore();
const route = useRoute();
const param = 'orderDir';

const value = ref('asc');

const data = computed(() => [
  { value: 'asc', text: t('Ascending') },
  { value: 'desc', text: t('Descending') },
]);

const icon = computed(() =>
  value.value === 'asc' ? 'fas fa-sort-amount-up' : 'fas fa-sort-amount-down',
);

const syncTemporaryQuery = (pick: boolean) => {
  if (pick) {
    const cacheUrl = query.decode(route.params.data as string) || {};
    const cacheStore = store.dashboardQuery;
    value.value = (cacheUrl[param] as string) || value.value || (cacheStore[param] as string) || 'asc';
  }
  store.patchDashboardQueryTemporaryField({ name: param, value: value.value });
};

onMounted(() => {
  value.value = store.user.dashboardDefaultOrderDir || 'asc';
  store.dashboardOrderDir = value.value;
  syncTemporaryQuery(true);
});

watch(value, (val) => {
  store.dashboardOrderDir = val;
  syncTemporaryQuery(false);
});
</script>
